import React from "react";
import { useLocation } from "react-router-dom";
import TourBookingForm from "../components/TourBookingForm";

const TourBookingPage = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const distributorId = query.get("distributor") || query.get("distributorId");

  if (!distributorId) {
    return <p>Invalid booking link — distributor ID is missing.</p>;
  }

  return <TourBookingForm />;
};

export default TourBookingPage;
